module.exports = __webpack_public_path__ + "img/workDocs.1df0cac2.png";